var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoPremiumDiamond = function SvgNoPremiumDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.498 11.981 12 13.938l5.005-3.913-1.33-1.398H8.09L5.12 11.98 12 17.572l6.881-5.59M3.398 21.057l.931-.931M20.124 4.33l-1.062 1.062M9.026 22.955c.888.242 1.822.371 2.787.371 5.832 0 10.56-4.728 10.56-10.56 0-.964-.13-1.899-.372-2.786M14.03 2.44a10.6 10.6 0 0 0-2.217-.233c-5.832 0-10.56 4.727-10.56 10.56q.002 1.142.233 2.216"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .6h24v24H0z"
  })))));
};
export default SvgNoPremiumDiamond;